import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { updateUserData } from '../../actions/AppActions';
import FlexPanel from '../FlexPanel';

const PanelWidget = ({ menu = [], className = '', header, name, children }) => {
  const dispatch = useDispatch();

  const hide = () => {
    dispatch(updateUserData(`widgets.${name}`, { show: false }));
  };

  const renderMenu = () => (
    <Dropdown title="Widget Options" alignRight id={`widget-options-${name}`} className="no-caret">
      <Dropdown.Toggle className="more-options" variant="link">
        <i className="zmdi zmdi-more-vert" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {menu.map((item, i) => {
          return <Dropdown.Item key={`wmi-${i}`}>{item}</Dropdown.Item>;
        })}
        {!!menu.length && <Dropdown.Divider />}
        <Dropdown.Item onClick={hide}>Hide</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  const headerComp = (
    <>
      <div className="float-right">{renderMenu()}</div>
      <div className="header-text">{header}</div>
    </>
  );

  return (
    <FlexPanel header={headerComp} className={classNames('panel-widget', className)}>
      {children}
    </FlexPanel>
  );
};

PanelWidget.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  menu: PropTypes.array,
  name: PropTypes.string,
};

export default PanelWidget;
